import { isPresent } from './ObjectHelper'

export function stringifyLocation(location) {
  return isPresent(location)
    ? `${location.street}, ${location.city}, ${location.state} ${
        location.postal_code
      }`
    : ''
}
